import React from 'react';
import { Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableHead, TableRow, Link } from '@mui/material';
import { DirectionsDocumentDto } from '../../models/analytics/directions/directionsModels';
import { DateUtils } from '../../helpers/dateUtils';

interface Props {
    open: boolean;
    onClose: () => void;
    driverFio: string;
    documents: DirectionsDocumentDto[];
    onDocumentDownload: (documentId: number) => void;
}

export const DirectionsDocumentsModal: React.FC<Props> = ({ open, onClose, driverFio, documents, onDocumentDownload }) => {
    const handleDocumentClick = async (documentId: number) => {
        await onDocumentDownload(documentId);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>История направлений — {driverFio}</DialogTitle>
            <DialogContent>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Дата отправки</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {documents.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={1}>Нет документов</TableCell>
                            </TableRow>
                        ) : (
                            documents.map((doc, i) => (
                                <TableRow key={`doc-${doc.id}-${i}`}>
                                    <TableCell>
                                        <Link
                                            component="button"
                                            underline="hover"
                                            onClick={() => handleDocumentClick(doc.id)}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            {DateUtils.formatDateTime(doc.sendDate)}
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </DialogContent>
        </Dialog>
    );
};

